import React from "react";

export const PASSWORD_REQUIREMENTS =
  "Use at least 15 characters. Passphrases, spaces, and Unicode are allowed. Avoid common passwords.";

export function passwordStrength(value) {
  const length = Array.from(value || "").length;
  if (!length) return "";
  if (length < 15) return "Too short";
  if (length < 20) return "Fair";
  return "Strong";
}

export default function PasswordHint({ value }) {
  const strength = passwordStrength(value);
  return (
    <p className="password-hint">
      {PASSWORD_REQUIREMENTS}
      {strength ? ` Strength: ${strength}.` : ""}
    </p>
  );
}
